export const SCREEN_RESTRICTION_KEYS = {
  ADMIN_DASHBOARD: 'admin_dashboard',
  ADMIN_REGISTRATION: 'admin_registration',
  VOUCHER_CAMPAIGN: 'voucher_campaign',
  GIFT_CARD: 'gift_card',
  GENERAL_CAMPAIGN: 'general_campaign',
  VOUCHER_LEGACY: 'voucher_legacy'
};
